<template>
  <v-autocomplete
    dense
    solo
    flat
    clearable
    hide-selected
    attach
    chips
    small-chips
    multiple
    class="filter-item"
    :value="value"
    :label="filterData.label"
    :items="items"
    :item-value="filterData['item-value']"
    :item-text="filterData['item-text']"
    :loading="isLoading"
    :search-input.sync="searchInput"
    :menu-props="{ maxHeight: 300, offsetY: true }"
    no-data-text="Type at least 2 characters to search"
    @change="handleChange"
  >
    <template v-slot:selection="data">
      <v-chip
        small
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click:close="handleRemoveSelection(data.item[filterData['item-value']])"
      >
        {{ data.item[filterData['item-text']] }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from "lodash";
import {
  SEARCH_VENDOR_OFFER_TAG_FILTER_VALUES,
  SEARCH_VENDOR_OFFER_MAPPING_FILTER_VALUES,
} from "@/store/vendorOffer.module";

export default {
  name: "FilterSearchAutocomplete",

  props: {
    filterData: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchInput: null,
      searchResults: [],
      isLoading: false,
    };
  },

  computed: {
    items() {
      const itemValueKey = this.filterData["item-value"];
      const itemTextKey = this.filterData["item-text"];
      const selectedItems = (this.value || []).map((selectedValue) => ({
        [itemValueKey]: selectedValue,
        [itemTextKey]: selectedValue,
      }));

      const merged = [...selectedItems];

      this.searchResults.forEach((item) => {
        if (!merged.some((existing) => existing[itemValueKey] === item[itemValueKey])) {
          merged.push(item);
        }
      });

      return merged;
    },
  },

  watch: {
    searchInput() {
      this.debouncedSearch();
    },
  },

  methods: {
    debouncedSearch: debounce(function () {
      this.search();
    }, 400),

    search() {
      if (!this.searchInput || this.searchInput.length < 2) {
        this.searchResults = [];
        this.isLoading = false;
        return;
      }

      const action = this.filterData.type === "tag_autocomplete"
        ? SEARCH_VENDOR_OFFER_TAG_FILTER_VALUES
        : SEARCH_VENDOR_OFFER_MAPPING_FILTER_VALUES;

      const params = this.filterData.type === "tag_autocomplete"
        ? { categoryId: this.filterData.category_id, query: this.searchInput }
        : { tagId: this.filterData.tag_id, query: this.searchInput };

      this.isLoading = true;

      this.$store
        .dispatch(action, params)
        .then((results) => {
          this.searchResults = results || [];
        })
        .catch(() => {
          this.searchResults = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleChange(values) {
      this.$emit("input", values || []);
    },

    handleRemoveSelection(itemValue) {
      const nextValues = (this.value || []).filter((value) => value !== itemValue);
      this.$emit("input", nextValues);
    },
  },
};
</script>
